import { render, staticRenderFns } from "./TextFieldWithCopyDefaultButton.vue?vue&type=template&id=07ecb10a&scoped=true&"
import script from "./TextFieldWithCopyDefaultButton.vue?vue&type=script&lang=js&"
export * from "./TextFieldWithCopyDefaultButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ecb10a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07ecb10a')) {
      api.createRecord('07ecb10a', component.options)
    } else {
      api.reload('07ecb10a', component.options)
    }
    module.hot.accept("./TextFieldWithCopyDefaultButton.vue?vue&type=template&id=07ecb10a&scoped=true&", function () {
      api.rerender('07ecb10a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomInputComponents/TextFieldWithCopyDefaultButton.vue"
export default component.exports